var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _path12, _path13, _path14, _path15, _path16, _circle, _circle2, _circle3, _circle4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchHospital(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 80,
    viewBox: "0 0 115 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10982_47756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.3685 29H19.6315C18.1782 29 17 30.1782 17 31.6315V78H71V31.6315C71 30.1782 69.8218 29 68.3685 29Z",
    fill: "#FFDBED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3685 3H37.6315C36.1782 3 35 4.17816 35 5.63149V77H71V5.63149C71 4.17816 69.8218 3 68.3685 3Z",
    fill: "#FFEBF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5637 29H41.3535V38.2102H50.5637V29Z",
    fill: "#F0C1D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5637 43H41.3535V52.2102H50.5637V43Z",
    fill: "#F0C1D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6392 29H54.429V38.2102H63.6392V29Z",
    fill: "#F0C1D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6392 43.3423H54.429V52.5525H63.6392V43.3423Z",
    fill: "#F0C1D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5176 33.2627H20.7761V42.957H30.5176V33.2627Z",
    fill: "#F0C1D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5176 47.7358H20.7761V57.4302H30.5176V47.7358Z",
    fill: "#F0C1D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5176 61H20.7761V70.6943H30.5176V61Z",
    fill: "#F0C1D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5113 7.60498H51.8798C51.5165 7.60498 51.2219 7.89952 51.2219 8.26285V22.736C51.2219 23.0994 51.5165 23.3939 51.8798 23.3939H54.5113C54.8746 23.3939 55.1692 23.0994 55.1692 22.736V8.26285C55.1692 7.89952 54.8746 7.60498 54.5113 7.60498Z",
    fill: "#002E52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4321 13.5264H45.9589C45.5956 13.5264 45.301 13.8209 45.301 14.1842V16.8157C45.301 17.1791 45.5956 17.4736 45.9589 17.4736H60.4321C60.7954 17.4736 61.09 17.1791 61.09 16.8157V14.1842C61.09 13.8209 60.7954 13.5264 60.4321 13.5264Z",
    fill: "#002E52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7212 60H41.3535V75.7889H63.7212V60Z",
    fill: "#F0C1D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7932 54.1995L20.5544 57.4634L8.58597 71.227L4.82474 67.9631L16.7932 54.1995Z",
    fill: "#7DAED4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.68456 75.3215L1.72774 75.359C2.91399 76.3888 4.50292 76.5023 5.27655 75.6128L14.2023 65.5053L9.82673 61.5381L0.936632 71.8468C0.163001 72.7363 0.497739 74.2919 1.68399 75.3217L1.68456 75.3215Z",
    fill: "#002E52"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.848 39.7257C11.3213 46.3605 13.858 54.6117 20.5322 58.1497C27.2064 61.6876 35.4713 59.1621 38.9981 52.5273C42.5248 45.8924 39.9881 37.6412 33.3139 34.1033C26.6397 30.5654 18.3748 33.0908 14.848 39.7257Z",
    stroke: "#002E52",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.388 57.2914C24.1276 59.2101 17.4972 55.6906 15.5784 49.4302C13.6596 43.1699 17.1792 36.5394 23.4395 34.6207C29.6999 32.7019 36.3304 36.2215 38.2491 42.4818C40.1679 48.7422 36.6483 55.3726 30.388 57.2914Z",
    fill: "#7DAED4",
    fillOpacity: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49022 60.8121L9.49022 60.8121L9.45368 60.8619C9.20987 61.192 9.25622 61.6529 9.55998 61.9282L9.49022 60.8121ZM9.49022 60.8121L9.49122 60.8107C9.77408 60.4279 10.3276 60.3751 10.6775 60.6987C10.6776 60.6988 10.6776 60.6988 10.6776 60.6988L14.8087 64.5179L14.8087 64.5179C15.1379 64.8223 15.1523 65.3367 14.8417 65.6593L14.8418 65.6593L14.8394 65.6617L14.8349 65.6663C14.5351 65.9756 14.043 65.993 13.7231 65.7028C13.7231 65.7028 13.723 65.7027 13.723 65.7027C13.723 65.7027 13.7229 65.7026 13.7229 65.7026L9.56006 61.9283L9.49022 60.8121Z",
    fill: "#F0C1D9",
    stroke: "#F0C1D9",
    strokeWidth: 0.846844
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0224 46.4363C17.0224 46.4363 19.6033 51.1349 26.6281 51.1349C33.6529 51.1349 36.6687 46.4363 36.6687 46.4363C36.6687 46.4363 33.2977 41.7378 26.6281 41.7378C20.4768 41.7378 17.0224 46.4363 17.0224 46.4363Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0407 50.7773C22.6363 49.7842 21.4945 47.0357 22.4904 44.6383C23.4864 42.2409 26.2429 41.1025 28.6472 42.0955C31.0516 43.0885 32.1934 45.837 31.1975 48.2344C30.2015 50.6318 27.445 51.7703 25.0407 50.7773Z",
    fill: "#002E52"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0509 44.3149C24.0509 44.9691 24.5837 45.5004 25.2398 45.5004C25.8959 45.5004 26.4287 44.9691 26.4287 44.3149C26.4287 43.6607 25.8959 43.1294 25.2398 43.1294C24.5837 43.1294 24.0509 43.6607 24.0509 44.3149Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0797 52C70.1755 52 59.7146 58.9451 59.7146 67.5122V71.3903C59.7146 72.9318 66.1007 75.9065 67.6412 75.9619C68.3233 75.9865 69.1053 76 70.0003 76C78.6636 76 91.1897 76 101.094 76C103.388 76 105.653 75.5127 107.744 74.5704C107.984 74.4627 108.239 74.396 108.498 74.3541C110.623 74.0099 112.286 72.8558 112.286 71.3903V67.5122C112.286 58.9451 101.825 52 88.9209 52H83.0797Z",
    fill: "#7DAED4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.6478 53.1004C95.7827 57.3781 91.2681 60.5714 85.7144 60.5714C80.2361 60.5714 75.7688 57.4642 73.8584 53.274C76.7051 52.4543 79.8458 52 83.1463 52H88.9876C92.0473 52 94.9697 52.3905 97.6478 53.1004Z",
    fill: "#F0C1D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.4234 36.6622C97.427 36.5372 97.4289 36.4117 97.4289 36.2857C97.4289 29.5005 92.0563 24 85.4289 24C78.8015 24 73.4289 29.5005 73.4289 36.2857C73.4289 36.4117 73.4307 36.5372 73.4344 36.6622C72.395 37.333 71.7146 38.4499 71.7146 39.7143C71.7146 41.3189 72.8104 42.6858 74.345 43.2051C75.8212 48.2316 81.7041 52 85.4289 52C89.1537 52 95.0366 48.2316 96.5128 43.2051C98.0474 42.6858 99.1432 41.3189 99.1432 39.7143C99.1432 38.4499 98.4627 37.333 97.4234 36.6622Z",
    fill: "#F0C1D9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80.2859,
    y: 48.5713,
    width: 10.2857,
    height: 6.28571,
    fill: "#F0C1D9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.286 75.9999C70.8574 61.7141 76.5717 52.5713 76.5717 52.5713C57.7145 56.2856 58.0002 70.5713 58.0002 75.9999H70.286Z",
    fill: "#E580B2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M102 75.9999C101.429 61.7141 95.7144 52.5713 95.7144 52.5713C114.572 56.2856 114.286 70.5713 114.286 75.9999H102Z",
    fill: "#E580B2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80.286 72.0924L79.6287 65.798C79.3918 63.5296 77.4795 61.8066 75.1988 61.8066V61.8066C72.9475 61.8066 71.0502 63.4865 70.7776 65.7212L70.0002 72.0924",
    stroke: "#002E52",
    strokeWidth: 2.28571,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1431 61.1426L75.1431 53.1426",
    stroke: "#002E52",
    strokeWidth: 2.28571,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1431 63.9997V53.1426",
    stroke: "#002E52",
    strokeWidth: 2.28571,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.0002,
    cy: 71.9999,
    r: 1.42857,
    fill: "#002E52",
    stroke: "#002E52",
    strokeWidth: 0.571429
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.2858,
    cy: 71.9999,
    r: 1.42857,
    fill: "#002E52",
    stroke: "#002E52",
    strokeWidth: 0.571429
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.143,
    cy: 67.4284,
    r: 4.28571,
    fill: "#002E52",
    stroke: "#002E52",
    strokeWidth: 0.571429
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.1431,
    cy: 67.4283,
    r: 2.28571,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10982_47756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 73,
    fill: "white",
    transform: "translate(17 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchHospital);
export default __webpack_public_path__ + "static/media/SearchHospital.9746ec8ab9a751f920d822f785843c21.svg";
export { ForwardRef as ReactComponent };